import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import {
  savePreferences,
  COMPETITION_RECOMMENDATION_PAGE_SIZES,
} from '@bingads-webui-campaign/recommendation-core';
import { Pagination } from '@bingads-webui-react/pagination';

import { IndividualRecommendation } from './individual-recommendation';

const childName = index => `reco-${index}`;

export class DetailsRecommendations extends React.PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.any).isRequired,
    deps: PropTypes.shape({
      i18n: PropTypes.PropTypes.shape({
        getString: PropTypes.func.isRequired,
      }).isRequired,
      locationMap: PropTypes.func.isRequired,
      preferencesService: PropTypes.objectOf(PropTypes.any).isRequired,
    }).isRequired,
    type: PropTypes.string.isRequired,
    dataService: PropTypes.objectOf(PropTypes.any).isRequired,
    reload: PropTypes.func.isRequired,
    el: PropTypes.string.isRequired,
    preferencesName: PropTypes.string.isRequired,
    pageSize: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    currentActivity: PropTypes.objectOf(PropTypes.any).isRequired,
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.shape({
      Level: PropTypes.string.isRequired,
    }).isRequired,
    guid: PropTypes.string.isRequired, // for adinsight view event log in aria
  };

  constructor() {
    super();
    this.recommendationRefs = {};
    this.storeCurrentPageRecommendationRef = (ref) => {
      if (ref !== null) {
        const {
          props: { name },
        } = ref;
        this.recommendationRefs[name] = ref;
      }
    };
  }

  getUserInputs() {
    const inputs = [];
    _.each(this.props.data, (recommendation, index) => {
      const recommendationRef = this.recommendationRefs[childName(index)];
      const inputsArr = recommendationRef.getUserInputs();
      if (inputsArr) {
        inputs.push(...inputsArr);
      }
    });

    return _.isEmpty(inputs) ? null : inputs;
  }

  savePageInformationToPreference(pageSize) {
    savePreferences(
      this.props.deps.preferencesService,
      this.props.preferencesName,
      {
        pageSize,
      }
    );
  }

  handlePageSizeChange = (e) => {
    this.savePageInformationToPreference(parseInt(e.target.value, 10));
    this.props.reload({
      pageNumber: 0,
    });
  }

  handlePageNumberChange = (pageNumber) => {
    this.props.reload({
      pageNumber,
    });
  }

  render() {
    const {
      data, deps, reload, pageNumber, pageSize, total,
    } = this.props;
    const { i18n } = deps;

    const passThroughPropsToIndividual = [
      'deps', 'type', 'dataService', 'el', 'currency',
      'currentActivity', 'readOnly', 'context', 'guid',
      'logExpInfo',
    ];
    const recommendationsInCurrentPage =
      _.map(data, (recommendation, index) =>
        (<IndividualRecommendation
          key={index}
          name={`${childName(index)}`}
          {...recommendation}
          ref={this.storeCurrentPageRecommendationRef}
          index={index}
          callback={reload}
          {..._.pick(this.props, passThroughPropsToIndividual)}
        />));

    const pageSizeOption = _.map(COMPETITION_RECOMMENDATION_PAGE_SIZES, (pageSizeVal, index) => (
      <option key={index} value={pageSizeVal}> {pageSizeVal}</option>));

    const pagination = (
      <div className="details-pagination">
        <div className="text">
          <span>{i18n.getString('Details_View_Show_Rows')}</span>
        </div>
        <div className="page-size-selector">
          <select value={pageSize} onChange={this.handlePageSizeChange}>
            {pageSizeOption}
          </select>
        </div>
        {total > pageSize &&
          <div className="pager">
            <Pagination
              onPageNumberChanged={this.handlePageNumberChange}
              pageNumber={pageNumber}
              itemCount={total}
              pageSize={pageSize}
              pageText=""
              totalPageCountText={i18n.getString('Details_View_Pagination_Of')}
              i18n={i18n}
            />
          </div>
        }
      </div>);

    const isFormAction = !_.isEmpty(data[0].actionDataInForm);
    const gridStyle = isFormAction ? 'form-action-details-grid' : 'grid-action-details-grid';

    return (
      <div className={`recommendation-details-container ${gridStyle}`}>
        <div className="details-header details-insight-col">
          <strong>{i18n.getString('Details_View_Whats_Going_On')}</strong>
        </div>
        <div className="details-header details-separator-col-1" />
        <div className="details-header details-action-col">
          <strong>{i18n.getString('Details_View_What_You_Can_Do')}</strong>
        </div>

        <div className="details-header details-separator-col-2" />
        <div className="details-header details-estimates-col">
          <strong >{i18n.getString('Details_View_Whats_You_Could_Get')}</strong>
        </div>
        {recommendationsInCurrentPage}
        {pagination}
      </div>
    );
  }
}
